import { FamilyParentProfile, UserRole } from "@joonapp/web-shared"
import { ModalHeader, Typography } from "@joonapp/web-shared"

import ChildSurveySectionItem from "./ChildSurveySectionItem"
import ParentSurveySectionItem from "./ParentSurveySectionItem"
import { useFamilyQuery } from "../../../networking/families/queries"
import { getSortedChildrenFromFamily } from "../../../util/profiles"
import useSurveysModalStore from "../store/useSurveysModalStore"

const SurveysOverview = () => {
  const { onClose } = useSurveysModalStore()
  const { data: family } = useFamilyQuery()

  const children = getSortedChildrenFromFamily(family)

  const parents = (family?.profiles.filter(
    (profile) => profile.role === UserRole.PARENT
  ) || []) as FamilyParentProfile[]

  return (
    <>
      <ModalHeader
        onClose={onClose}
        title="Intake Questionnaire"
        showBorderBottom
      />
      <div className="flex flex-col gap-6 p-6 pt-4 overflow-y-auto">
        <div className="flex flex-col gap-2">
          <Typography variant="bodySmallBold">Children</Typography>
          {children?.map((child) => (
            <ChildSurveySectionItem key={child.user.id} childProfile={child} />
          ))}
        </div>
        <div className="flex flex-col gap-2">
          <Typography variant="bodySmallBold">Parents</Typography>
          {parents?.map((parent) => (
            <ParentSurveySectionItem
              key={parent.user.id}
              parentProfile={parent}
            />
          ))}
        </div>
      </div>
    </>
  )
}

export default SurveysOverview
